import React from "react";
import styled from "styled-components";
import { Table, Container } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import ups from "./../../../assets/ups.png";

const Shipping = () => (
  <StyledShipping>
    <Container>
      <UnderlinedHeader text={"Opcje dostawy"} bolder />
      <p>Korzystamy z usług tych firm w celu dostarczenia Państwa towarów:</p>
      <div>
        <p>1. UPS Standard</p>
        <figure>
          <img src={ups} alt={"UPS"} />
          <figcaption>
            *Źródło: www.ups.com. The transit times reflect UPS' regular
            delivery schedule, but are not guaranteed
          </figcaption>
        </figure>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Kraj:</th>
              <th>Szacunkowy czas realizacji zamówienia (dni robocze)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Niemcy, Czechy, Słowacja</td>
              <td>2 dni</td>
            </tr>
            <tr>
              <td>Francja, Belgia, Dania, Holandia, Austria, Szwajcaria</td>
              <td>3 dni</td>
            </tr>
            <tr>
              <td>
                Wielka Brytania, Hiszpania, Włochy, Słowenia, Węgry, Rumunia
              </td>
              <td>4 dni</td>
            </tr>
            <tr>
              <td>
                Portugalia, Grecja, Chorwacja, Litwa, Łotwa, Estonia, Norwegia
              </td>
              <td>5 dni</td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div>
        2. UPS Express (1-2 dni robocze) - zamówienia złożone online do godziny
        13:00 są przetwarzane tego samego dnia
      </div>
      <div>
        <br />
        <p>3. DPD</p>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th style={{ width: "50%" }}>Kraj:</th>
              <th>DPD - Szacunkowy czas realizacji zamówienia (dni robocze)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Belgia</td>
              <td>3 dni</td>
            </tr>
            <tr>
              <td>Bułgaria</td>
              <td>5 dni</td>
            </tr>
            <tr>
              <td>Czechy</td>
              <td>3 dni</td>
            </tr>
            <tr>
              <td>Finlandia</td>
              <td>5 dni</td>
            </tr>
            <tr>
              <td>Francja</td>
              <td>4 dni</td>
            </tr>
            <tr>
              <td>Niemcy</td>
              <td>3 dni</td>
            </tr>
            <tr>
              <td>Grecja</td>
              <td>6 dni</td>
            </tr>
            <tr>
              <td>Włochy</td>
              <td>5 dni</td>
            </tr>
            <tr>
              <td>Holandia</td>
              <td>3 dni</td>
            </tr>
            <tr>
              <td>Polska</td>
              <td>1 dzień</td>
            </tr>
            <tr>
              <td>Portugalia</td>
              <td>5 dni</td>
            </tr>
            <tr>
              <td>Rumunia</td>
              <td>4 dni</td>
            </tr>
            <tr>
              <td>Hiszpania</td>
              <td>5 dni</td>
            </tr>
            <tr>
              <td>Szwecja</td>
              <td>4 dni</td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div>
        <br />
        <p>*Podana liczba dni nie obejmuje dnia wysyłki.</p>
      </div>
    </Container>
  </StyledShipping>
);

export default Shipping;

const StyledShipping = styled.section`
  padding-top: 92px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #666666;
`;
